const resource = {
  resources: "Ressources",
  resource: "Ressource",
  type: "Type",
  name: "Nom de la resource",
  description: "Description",
  linkToDocument: "Lien vers le document",
  missingLink: "Lien manquant",
};

export default resource;
